export default function PHP_constant() {
  return (
    <div>
      <h1>PHP_constant</h1>
    </div>
  );
}
